export const onServiceWorkerUpdateReady = () => {
    const answer = window.confirm(
      `New content is available. Reload to update?`
    );
    if (answer) window.location.reload();
  };
  
export const onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') return;

  const measurementId = process.env.GATSBY_GA4_MEASUREMENT_ID || 'G-ZCSRMS42JW';
  const pagePath = location.pathname + (location.search || '');

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event: 'page_view', page_path: pagePath });
  }

  if (typeof window.gtag === 'function' && measurementId) {
    window.gtag('event', 'page_view', { page_path: pagePath, send_to: measurementId });
  }
};
  
